// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveySessionPostRequest {
    static getAttributeTypeMap() {
        return SurveySessionPostRequest.attributeTypeMap;
    }
}
SurveySessionPostRequest.discriminator = undefined;
SurveySessionPostRequest.additionalProperties = false;
SurveySessionPostRequest.attributeTypeMap = [
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "surveySourceId",
        "baseName": "surveySourceId",
        "type": "number"
    },
    {
        "name": "sourceSystemId",
        "baseName": "sourceSystemId",
        "type": "string"
    },
];
//# sourceMappingURL=surveySessionPostRequest.js.map